const dialogPalette = (tokens) => {
    return {
        padding: {
            dense: tokens.dialogPaddingDense,
            default: tokens.dialogPaddingDefault,
            spacious: tokens.dialogPaddingSpacious
        },
        width: {
            small: tokens.dialogSizeSWidth,
            medium: tokens.dialogSizeMWidth,
            large: tokens.dialogSizeLWidth
        },
        border: {
            width: tokens.dialogBorderWidth,
            radius: tokens.dialogRadius,
            color: {
                default: tokens.dialogColorBorderDefault
            }
        },
        background: {
            color: {
                default: tokens.dialogColorBgDefault
            }
        }
    };
};
export default dialogPalette;
//# sourceMappingURL=dialog.js.map